// extracted by mini-css-extract-plugin
export default {"detail":"Forms_detail__DGqMP","fields":"Forms_fields__7j9SN"};